export default function SpinnerUAU() {
    return (
        <div className="d-flex flex-column align-items-center my-4">
            <span className="mb-3 font-weight-bold text-warning">
                Carregando dados do ERP
            </span>
            <div className="spinner-border text-warning" role="status">
                <span className="sr-only">Carregando...</span>
            </div>
        </div>
    );
}
